export default [
    {
        path: '/login',
        name: '登录页',
        component: () => import('../page/user/login')
    },
    {
        path: '/register',
        name: '注册',
        component: () => import('../page/user/register')
    }
]
